import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import styles from '../update-services/UpdateServices.module.scss'
import { Translate } from 'react-localize-redux'
import {
  Button,
  ButtonType,
  DatePicker,
  Form,
  FormGroup,
  Input,
  ModalTypes,
  StandardModal,
  SubmitButton,
  TextArea
} from '@digicert/dcone-common-ui'
import { translate } from 'shared/helpers/utils'
import { createApiToken, fetchApiTokens } from 'secure-pages/api-tokens/ApiTokens.actions'
import { ISort } from 'core/actions/Actions.interfaces'
import { disabledDateFromTo } from 'shared/helpers/DateTimeHelper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCopy } from '@fortawesome/pro-light-svg-icons'
import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc);

export const CreateApiToken = (
  { onCancel, fetchApiTokens, createApiToken, setTokens }) => {

  const [name, setName] = useState<string>('')
  const [nameExists, setNameExist] = useState<boolean>(false)
  const [date, setDate] = useState<Dayjs>()
  const [showApiTokenModal, setShowApiTokenModal] = useState(false)
  const [apiToken, setApiToken] = useState('')
  const [copiedInfo, setCopiedInfo] = useState(false)

  useEffect(() => {
    setName('')
    setNameExist(false)
    setDate(undefined)
  }, [onCancel])

  const handleCancel = (e) => {
    e.preventDefault()
    if (onCancel) {
      onCancel(e)
    }
  }

  const submit = (e) => {
    e.preventDefault()
    const payload = {
      name: name,
      end_date: date ? dayjs.utc(date).format() : null,
      enabled: true
    }

    createApiToken(payload).then(res => {
      setApiToken(res.token)
      fetchApiTokens().then(response => {
        setTokens(response.items)
      })
    })
    setShowApiTokenModal(true)
    handleCancel(e)
  }

  const onNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value)
  }

  const onApiTokenNameBlur = (event: ChangeEvent<HTMLInputElement>) => {
    onNameChange(event)
    const params: ISort = { limit: 20, offset: 0 }
    if (event.target.value.trim() !== '') {
      fetchApiTokens(params, { name: event.target.value.trim() }).then(res => {
        if (res.items.length > 0) {
          setNameExist(true)
        } else {
          setNameExist(false)
        }
      })
    }
  }

  const validateApiTokenName = useCallback(() => {
    if (nameExists) {
      return translate('common.form.validation.alreadyUsed') as string
    }
  }, [nameExists])

  const onDateChange = useCallback((value, dateString) => {
    setDate(value);
  }, [date]);

  const copyToClipboard = (): void => {
    setCopiedInfo(true)
    navigator.clipboard.writeText(apiToken);
    setTimeout(() => setCopiedInfo(false), 1000)
  }

  return (
    <>
      <div className={styles.editServices}>
        <Form center={false} onSubmit={(e) => submit(e)}>

          <FormGroup>
            <Input
              name='api_token_name'
              label={<Translate id='common.form.name' />}
              required
              value={name}
              errors={{
                valueMissing: translate('common.form.validation.required')
              }}
              className={styles.apiName}
              onChange={onNameChange}
              validate={validateApiTokenName}
              onBlur={(event) => onApiTokenNameBlur(event)}
            />
          </FormGroup>
          <FormGroup>
            <DatePicker
              label={translate('serviceUser.endDate')}
              id='api_token_datepicker'
              value={date}
              onChange={onDateChange}
              disabledDate={disabledDateFromTo(dayjs.utc().format('YYYY-MM-DD'))}
            />
          </FormGroup>

          <div className={styles.formActions}>
            <Button buttonType={ButtonType.SECONDARY} onClick={handleCancel}>
              <Translate id='common.form.buttons.cancelBtn' />
            </Button>
            <SubmitButton>
              <Translate id='apiTokens.createBtn' />
            </SubmitButton>
          </div>

        </Form>
      </div>
      {showApiTokenModal &&
        <StandardModal
          modalType={ModalTypes.STANDARD}
          headline={translate('apiTokens.created') as string}
          display={showApiTokenModal}
          buttonLabel={translate('common.form.buttons.closeBtn') as string}
          hideCancelButton={true}
          buttonCancelLabel=''
          onCancelCallBack={() => setShowApiTokenModal(false)}
          onOkCallBack={() => setShowApiTokenModal(false)}
        >
          <p>{translate('apiTokens.copyMsg')}</p>
          <TextArea
            required
            label={translate('apiTokens.apiKey')}
            value={apiToken}
            rows={2}
          />
          {copiedInfo && (
            <div className={styles.copiedContainer} onClick={copyToClipboard}>
              <FontAwesomeIcon size='lg' icon={faCheck} className={styles.clipBoardIcon} /><p>{translate('apiTokens.copied')}</p>
            </div>

          )
          }
          {!copiedInfo && (
            <div className={styles.copyContainer} onClick={copyToClipboard}>
              <FontAwesomeIcon size='lg' icon={faCopy} className={styles.clipBoardIcon} /> <p>{translate('apiTokens.copy')}</p>
            </div>

          )
          }
        </StandardModal>
      }
    </>
  )
}

export default connect(
  (state: IAppState) => {
    return {
    }
  },
  {
    createApiToken,
    fetchApiTokens
  }
)(CreateApiToken)
